import React, { useState, useRef } from "react";
import "./OtpPage.css";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
// import { verifyPassword,forgetPassword } from "../../redux/api/auth/userAuth";
import {verifyPassword,forgetPassword} from '../../redux/api/auth/authApi'
import { Spinner } from "@chakra-ui/react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const OtpPage =()=> {
  const [isResending, setIsResending] = useState(false);
  const [disableResend, setDisableResend] = useState(false); // New state for disabling the button

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const combinedOtp = otp.join(""); 
  const email = sessionStorage.getItem("tempEmail");
  const inputRefs = useRef([]);
  const handleSubmit = async (e) => {
    setIsResending(true);
    setDisableResend(true);
    e.preventDefault();
    setIsLoading(true);

    const data = {
      email,
      otp: combinedOtp,
    };
    console.log("data", data);

    try {
      const otpResp = await verifyPassword(data);
      if (otpResp.success) {
        setIsLoading(false);
        toast.success("OTP verified successfully!");
        navigate("/");
      } else if (otpResp.staus === 203) {
        toast.error("Invalid OTP.");
        setIsLoading(false);
      } else {
        toast.error("Invalid OTP Verification");
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      toast.error("An error occurred. Please try again.");
      console.log(e);
    }
  };
  const handleResendOtp = async () => {
    setIsResending(true);
    setDisableResend(true);
    try {
        const resendResponse = await forgetPassword({ email }); 
        if (resendResponse.success) {
            toast.success("OTP has been resent successfully!");
        } else {
            toast.error("Failed to resend OTP. Please try again.");
        }
    } catch (error) {
        toast.error("An error occurred while resending OTP.");
        console.error(error);
    }
    setIsResending(false);
    setTimeout(() => {
        setDisableResend(false);
    }, 60000); 
};
const handleChange = (index, e) => {
  const value = e.target.value;
  if (!/^\d?$/.test(value)) return; 

  const newOtp = [...otp];
  newOtp[index] = value;
  setOtp(newOtp);

  if (value && index < inputRefs.current.length - 1) {
    inputRefs.current[index + 1].focus();
  }
};
const handleKeyDown = (index, e) => {
  if(e.key === "Backspace" && !otp[index] && index > 0) {
     inputRefs.current[index - 1].focus();
    }
}
  return (
    <>
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      <div>
        <div className="row mt-4">
          <div className="col-lg-4 col-md-3"></div>
          <div className="col-lg-4 col-md-6 mt-5">
            <div className="bg-white p-5 rounded-3 shadow-sm border">
              <div>
                <div className="d-flex justify-content-center">
                  <ShieldCheck className="verification" />
                </div>
                <p
                  className="text-center text-success"
                  style={{ fontSize: "5.5rem" }}
                >
                  <i className="fa-solid fa-envelope-circle-check"></i>
                </p>
                <p className="text-center h5">Please Check Your Email</p>
                <p className="text-muted text-center">
                  We've sent a code to contact@curfcode.com
                </p>
                <div className="row pt-4 pb-2">
                  {/* <div className="col-lg-12 d-flex justify-content-center">
                    <input
                      className="otp-letter-input m-1"
                      onChange={(e) => setOtpFirst(e.target.value)}
                      type="text"
                      maxLength={1}
                    />
                    <input
                      className="otp-letter-input m-1"
                      onChange={(e) => setOtpSecond(e.target.value)}
                      type="text"
                      maxLength={1}
                    />
                    <input
                      className="otp-letter-input m-1"
                      onChange={(e) => {
                        setOtpThird(e.target.value);
                      }}
                      type="text"
                      maxLength={1}
                    />
                    <input
                      className="otp-letter-input m-1"
                      onChange={(e) => {
                        setOtpFourth(e.target.value);
                      }}
                      type="text"
                      maxLength={1}
                    />
                  </div> */}
                     <div className="col-lg-12 d-flex justify-content-center">
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          className="otp-letter-input m-1"
          type="text"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)} // Detect backspace
        />
      ))}
    </div>
                </div>
                <p className="text-muted text-center">
                  Didn't get the code ?
                  <button
                    className="btn btn-link p-0"
                    style={{
                      color: "#ff176b",
                      cursor: disableResend ? "not-allowed" : "pointer",
                    }}
                    onClick={handleResendOtp}
                    disabled={disableResend}
                  >
                    {isResending ? "Resending..." : "Click to resend"}
                  </button>
                </p>

                <div className="d-flex flex-row-reverse mt-4 pt-4">
                  <Link to="/change-password">
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className="btn  search-button ms-2"
                    >
                      Verify
                    </button>
                  </Link>

                  <button type="submit" className="btn  cancel-button">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-3"></div>
        </div>
      </div>
    </>
  );
}


export default OtpPage;